import { FC } from 'react';
import { App as AntdApp } from 'antd';
import { GlobalSpinnerProvider } from 'app/providers/GlobalSpinner';
import { GlobalSpinner } from 'shared/ui/GlobalSpinner';
import { ModalWrapper } from 'widgets/ModalWrapper';
import { BrowserRouter } from './providers/Router';
import { StoreProvider } from './providers/Store';
import './styles/index.scss';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import { ThemeProvider } from './providers/ThemeProvider';

const App: FC = () => (
  <div className="app" data-testid="app-div">
    <StoreProvider>
      <GlobalSpinnerProvider>
        <ThemeProvider>
          <AntdApp>
            <BrowserRouter />
            <ModalWrapper />
            <GlobalSpinner />
          </AntdApp>
        </ThemeProvider>
      </GlobalSpinnerProvider>
    </StoreProvider>
  </div>
);

export default App;
